import axios from "axios";

// Base da API: REACT_APP_BACKEND_URL (ou /api atrás do nginx).
const BASE = process.env.REACT_APP_BACKEND_URL || "";
const API_BASE = BASE ? `${BASE}/api` : "/api";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // cookies de sessão (fluxo de login em etapas)
  headers: { "Content-Type": "application/json" },
});

// ---- token (JWE) em localStorage ----
let token = localStorage.getItem("token") || null;

export function setToken(newToken) {
  token = newToken;
  localStorage.setItem("token", newToken);
}
export function clearToken() {
  token = null;
  localStorage.removeItem("token");
}
export function getToken() {
  return token;
}

// Sessão expirada — emitido em vez de redirect forçado, para a UI mostrar
// um modal de re-login sem perder o estado da página.
export const SESSION_EXPIRED_EVENT = "session-expired";
function emitSessionExpired() {
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}

api.interceptors.request.use((config) => {
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

let isRefreshing = false;
let subscribers = [];
const onRefreshed = (t) => { subscribers.forEach((cb) => cb(t)); subscribers = []; };

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original.url?.includes("/auth/") &&
      !original._retry
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          subscribers.push((t) => {
            if (t) {
              original.headers["Authorization"] = `Bearer ${t}`;
              resolve(api(original));
            } else reject(error);
          });
        });
      }
      original._retry = true;
      isRefreshing = true;
      try {
        const res = await api.post("/auth/refresh");
        const t = res.data?.token;
        if (t) {
          setToken(t);
          onRefreshed(t);
          original.headers["Authorization"] = `Bearer ${t}`;
          return api(original);
        }
      } catch {
        onRefreshed(null);
        emitSessionExpired();
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
